import {
  clsx,
  styled,
  Box
} from 'external/material'
import {
   range
  ,chunk
} from 'external/lodash'

import {Link} from 'external/react'

import {isEmpty} from 'utils/text'
import useTranslations from 'hooks/translations'
import useSession from 'hooks/session'

import QuestionLink, {QuestionLinkDummy} from './QuestionLink'

const SectionLinkContainer = styled(Box)(sectionStyles)

export default function Section ({index, section, sections, context}) {


  const {assessmentId, sectionId, questionId, navigation} = useSession()
  const {translate} = useTranslations()
  const {questions = []} = section

  const title = isEmpty(section.title) ? `${translate('section')} ${index + 1}` : section.title

  const chunkSize = 4
  const questionRows = chunk(questions.map((question, index) => (<QuestionLink key={question.id} {...{index, section, question, sections}}/>)), chunkSize)

  const addDummies = row => {
    const missing = chunkSize - row.length
    const newRow = missing == 0 ? row : row.concat(range(missing).map((_,index) => (<QuestionLinkDummy key={row.length + index} />)))
    return newRow
  }

  const sectionLink = assessmentId && navigation.assessmentSection.link({sectionId: section.id})

  const selected = section.id == sectionId && !questionId

  function handleClick (e) {
    selected && e.preventDefault()
  }

  return (
    <SectionLinkContainer className="root">
      <Link className={clsx("title", {selected})} onClick={handleClick} to={sectionLink}>
        {title}
      </Link>
      <Box className="questions">
        {questionRows.map((row, index) => (
          <Box key={index} className="questionRow">
            {addDummies(row)}
          </Box>
        ))}
      </Box>
    </SectionLinkContainer>
  )
}

export function sectionStyles (theme) {
  return {
    "& .title": {
      display: 'flex',
      padding: 10,
      textDecoration: 'none',
      color: '#5c6fcd',
      fontSize: '11pt',
      borderTop: 'solid 1px #e1e5e8',
      borderBottom: 'solid 1px #e1e5e8',
      borderLeft: 'solid 4px #577ee3',
      backgroundColor: '#fff7f3',
      "&.selected": {
        backgroundColor: '#577ee3',
        color: '#fff',
        cursor: 'default'
      }
    },
    "& .questions": {
      display: 'flex',
      flexDirection: 'column',
      padding: '10px 5px',
    },
    "& .questionRow": {
      display: 'flex',
      justifyContent: 'space-between',
      padding: 10,
    }
  }
}
